import { render, staticRenderFns } from "./completedHomeworkListTopbar.vue?vue&type=template&id=65c239d6&scoped=true"
import script from "./completedHomeworkListTopbar.vue?vue&type=script&lang=js"
export * from "./completedHomeworkListTopbar.vue?vue&type=script&lang=js"
import style0 from "./completedHomeworkListTopbar.vue?vue&type=style&index=0&id=65c239d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c239d6",
  null
  
)

export default component.exports